import { Permisos } from "./permisos";

export const CATEGORIAS = [
  "Administración",
  "Autorizacion",
  "Compañía",
  "Configuración",
  "Perfil",
  "Usuario",
  "Transacciones",
  "Transacciones / Detalles",
  "Transacciones / Reportes",
  "Anulación e-NCF",
  "Consultar Directorios",
  "Aprobación Comercial",
  "Comprobantes Recibidos",
  "Carga Masiva de e-CF",
  "Reporte",
  "Dashboard",
  "Documentación",
  "Serie Fiscal",
  "Item",
  "Compañía Padre",
  "Categoria",
  "Vendedor",
  "Terminal POS",
  "Forma de Pago",
  "Solicitudes",
  "Solicitudes / Documentos",
  "Terceros",
  "Carga Masiva",
  "Condición de Pago",
  "Auditoría",
  "Reporte 606",
  "Reporte 607",
  "Transacciones Recurrentes",
];

export const COLUMNA_LISTAR = "LISTAR";
export const COLUMNA_EDITAR = "EDITAR";
export const COLUMNA_CREAR = "CREAR";
export const COLUMNA_CANCELAR = "CANCELAR";
export const COLUMNA_OTROS = "OTROS";
export const COLUMNA_IMPRIMIR = "IMPRIMIR";

export const PERMISOS_CONFIG = [

  // Administración
  { nombre: Permisos.Compania.LISTAR, categoria: "Administración", columna: COLUMNA_LISTAR },
  { nombre: Permisos.Compania.EDITAR, categoria: "Administración", columna: COLUMNA_EDITAR },
  { nombre: Permisos.Compania.CREAR, categoria: "Administración", columna: COLUMNA_CREAR },
  { nombre: Permisos.SolicitudTenant.LISTAR, categoria: "Administración", columna: COLUMNA_OTROS, label: "Listar Solicitudes" },
  { nombre: Permisos.SolicitudTenant.EVALUAR, categoria: "Administración", columna: COLUMNA_OTROS, label: "Evaluar Solicitudes" },
  { nombre: Permisos.Compania.INGRESAR_COMPANIA, categoria: "Administración", columna: COLUMNA_OTROS, label: "Cambiar Compañía" },

  // Autorizacion
  { nombre: Permisos.Seguridad.CREAR_TOKEN, categoria: "Autorizacion", columna: COLUMNA_CREAR },
  { nombre: Permisos.Seguridad.INACTIVAR_TOKEN, categoria: "Autorizacion", columna: COLUMNA_CANCELAR },

  // Compañía
  { nombre: Permisos.Seguridad.CONFIGURACION_EDIATR_CIA, categoria: "Compañía", columna: COLUMNA_EDITAR },

  // Configuración
  { nombre: Permisos.Seguridad.CONFIGURACION_LISTAR, categoria: "Configuración", columna: COLUMNA_LISTAR },
  { nombre: Permisos.Seguridad.SACAR_USUARIO_SESION, categoria: "Configuración", columna: COLUMNA_OTROS, label: "Cerrar sesión usuarios" },
  { nombre: Permisos.Usuario.ACTUALIZAR_PASSWORD, categoria: "Configuración", columna: COLUMNA_OTROS, label: "Cambiar Contraseña usuarios" },
  { nombre: Permisos.MiCuenta.VER, categoria: "Configuración", columna: COLUMNA_OTROS, label: "Ver Mi Cuenta" },
  { nombre: Permisos.Soporte.WHATSAPP_VER, categoria: "Configuración", columna: COLUMNA_OTROS, label: "Ver Whatsapp" },

  // Perfil
  { nombre: Permisos.Perfil.LISTAR, categoria: "Perfil", columna: COLUMNA_LISTAR },
  { nombre: Permisos.Perfil.EDITAR, categoria: "Perfil", columna: COLUMNA_EDITAR },
  { nombre: Permisos.Perfil.CREAR, categoria: "Perfil", columna: COLUMNA_CREAR },

  // Usuario
  { nombre: Permisos.Usuario.LISTAR, categoria: "Usuario", columna: COLUMNA_LISTAR },
  { nombre: Permisos.Usuario.EDITAR, categoria: "Usuario", columna: COLUMNA_EDITAR },
  { nombre: Permisos.Usuario.CREAR, categoria: "Usuario", columna: COLUMNA_CREAR },

  // Transacciones
  { nombre: Permisos.ComprobanteElectronico.LISTAR, categoria: "Transacciones", columna: COLUMNA_LISTAR },
  { nombre: Permisos.ComprobanteElectronico.FIRMAR, categoria: "Transacciones", columna: COLUMNA_OTROS, label: "Firmar XML" },
  { nombre: Permisos.Transacciones.VISUALIZAR_LINK_QR, categoria: "Transacciones", columna: COLUMNA_OTROS, label: "Ver Link QR" },
  { nombre: Permisos.Transacciones.CANCELAR, categoria: "Transacciones", columna: COLUMNA_CANCELAR },
  { nombre: Permisos.Transacciones.CREAR, categoria: "Transacciones", columna: COLUMNA_CREAR },

  // Transacciones / Detalles
  { nombre: Permisos.Transacciones.EDITAR_PRECIO, categoria: "Transacciones / Detalles", columna: COLUMNA_OTROS, label: "Editar Precio" },
  { nombre: Permisos.Transacciones.EDITAR_ITBIS, categoria: "Transacciones / Detalles", columna: COLUMNA_OTROS, label: "Editar ITBIS" },
  { nombre: Permisos.Transacciones.EDITAR_RET_ITBIS, categoria: "Transacciones / Detalles", columna: COLUMNA_OTROS, label: "Editar Retención ITBIS" },
  { nombre: Permisos.Transacciones.EDITAR_RET_ISR, categoria: "Transacciones / Detalles", columna: COLUMNA_OTROS, label: "Editar Retención ISR" },

  // Transacciones / Reportes
  { nombre: Permisos.Facturas.IMPRIMIR, categoria: "Transacciones / Reportes", columna: COLUMNA_IMPRIMIR, label: "Imprimir Facturas" },
  { nombre: Permisos.FacturasConsumo.IMPRIMIR, categoria: "Transacciones / Reportes", columna: COLUMNA_IMPRIMIR, label: "Imprimir Facturas de Consumo" },
  { nombre: Permisos.NotaCredito.IMPRIMIR, categoria: "Transacciones / Reportes", columna: COLUMNA_IMPRIMIR, label: "Imprimir Nota Crédito" },
  { nombre: Permisos.NotaDebito.IMPRIMIR, categoria: "Transacciones / Reportes", columna: COLUMNA_IMPRIMIR, label: "Imprimir Nota Débito" },
  { nombre: Permisos.Exportaciones.IMPRIMIR, categoria: "Transacciones / Reportes", columna: COLUMNA_IMPRIMIR, label: "Imprimir Exportaciones" },

  // Anulación e-NCF
  { nombre: Permisos.AnulacionSecuencia.LISTAR, categoria: "Anulación e-NCF", columna: COLUMNA_LISTAR },
  { nombre: Permisos.AnulacionSecuencia.CREAR, categoria: "Anulación e-NCF", columna: COLUMNA_CREAR },

  // Consultar Directorios
  { nombre: Permisos.ConsultarDirectorios.LISTAR, categoria: "Consultar Directorios", columna: COLUMNA_LISTAR },

  // Aprobación Comercial
  { nombre: Permisos.AprobacionComercial.LISTAR, categoria: "Aprobación Comercial", columna: COLUMNA_LISTAR },
  { nombre: Permisos.AprobacionComercial.CREAR, categoria: "Aprobación Comercial", columna: COLUMNA_CREAR },

  // Comprobantes Recibidos
  { nombre: Permisos.ComprobantesRecibidos.LISTAR, categoria: "Comprobantes Recibidos", columna: COLUMNA_LISTAR },

  // Carga Masiva de e-CF
  { nombre: Permisos.Archivo.LISTAR, categoria: "Carga Masiva de e-CF", columna: COLUMNA_LISTAR },
  { nombre: Permisos.Archivo.INACTIVAR, categoria: "Carga Masiva de e-CF", columna: COLUMNA_CANCELAR },

  // Reporte
  { nombre: Permisos.Reportes.IMPRIMIR, categoria: "Reporte", columna: COLUMNA_IMPRIMIR, label: "Imprimir Reportes" },
  { nombre: Permisos.Reportes.VENTAS_POR_TIPO_COMPROBANTES_IMPRIMIR, categoria: "Reporte", columna: COLUMNA_IMPRIMIR, label: "Imprimir Venta Por Tipo Comprobante" },
  { nombre: Permisos.Reportes.CANTIDAD_TRANSACCIONES_POR_RANGO_FECHA_IMPRIMIR, categoria: "Reporte", columna: COLUMNA_IMPRIMIR, label: "Imprimir Cantidad Transacciones Por Fecha" },
  { nombre: Permisos.Reportes.TRANSACCIONES_POR_RANGO_FECHA_IMPRIMIR, categoria: "Reporte", columna: COLUMNA_IMPRIMIR, label: "Imprimir Transacciones Por Fecha" },

  // Dashboard
  { nombre: Permisos.Graficos.VER_GRAFICOS, categoria: "Dashboard", columna: COLUMNA_LISTAR },
  { nombre: Permisos.Graficos.CARD_VENTAS_MES, categoria: "Dashboard", columna: COLUMNA_OTROS, label: "Ver Ventas" },
  { nombre: Permisos.Graficos.CARD_TOTAL_VENTAS_MES, categoria: "Dashboard", columna: COLUMNA_OTROS, label: "Ver Total Ventas" },
  { nombre: Permisos.Graficos.CARD_TOTAL_COMPRAS_MES, categoria: "Dashboard", columna: COLUMNA_OTROS, label: "Ver Total Compras" },
  { nombre: Permisos.Graficos.CARD_INFORMACION_CERTIFICADO, categoria: "Dashboard", columna: COLUMNA_OTROS, label: "Ver Certificado" },
  { nombre: Permisos.Graficos.CARD_COMPRAS_MES, categoria: "Dashboard", columna: COLUMNA_OTROS, label: "Ver Compras" },
  { nombre: Permisos.Graficos.TABLA_VENTAS, categoria: "Dashboard", columna: COLUMNA_OTROS, label: "Ver Tabla Venta" },
  { nombre: Permisos.Graficos.TABLA_COMPRAS, categoria: "Dashboard", columna: COLUMNA_OTROS, label: "Ver Tabla Compras" },
  { nombre: Permisos.Graficos.GRAFICO_PIE_VENTAS, categoria: "Dashboard", columna: COLUMNA_OTROS, label: "Ver Comprobantes Ventas en pie" },
  { nombre: Permisos.Graficos.GRAFICO_PIE_COMPRAS, categoria: "Dashboard", columna: COLUMNA_OTROS, label: "Ver Comprobantes Compras en pie" },
  { nombre: Permisos.Graficos.GRAFICO_VENTAS, categoria: "Dashboard", columna: COLUMNA_OTROS, label: "Ver Comprobantes Ventas" },
  { nombre: Permisos.Graficos.GRAFICO_COMPRAS, categoria: "Dashboard", columna: COLUMNA_OTROS, label: "Ver Comprobantes Compras" },
  { nombre: Permisos.Graficos.GRAFICO_TRANSACCIONES_REALIZADAS, categoria: "Dashboard", columna: COLUMNA_OTROS, label: "Ver Transacciones Realizadas" },
  { nombre: Permisos.Graficos.GRAFICO_TOP_10_CLIENTES, categoria: "Dashboard", columna: COLUMNA_OTROS, label: "Ver principales 10 Clientes" },
  { nombre: Permisos.Graficos.GRAFICO_BOTTOM_10_CLIENTES, categoria: "Dashboard", columna: COLUMNA_OTROS, label: "Ver últimos 10 Clientes" },
  { nombre: Permisos.Graficos.GRAFICO_TOP_10_PROVEDORES, categoria: "Dashboard", columna: COLUMNA_OTROS, label: "Ver principales 10 Proveedores" },
  { nombre: Permisos.Graficos.GRAFICO_BOTTOM_10_PROVEDORES, categoria: "Dashboard", columna: COLUMNA_OTROS, label: "Ver últimos 10 Proveedores" },

  // Documentación
  { nombre: Permisos.Documentacion.DOCUMENTACION_LISTAR, categoria: "Documentación", columna: COLUMNA_OTROS, label: "Ver Documentación API" },
  { nombre: Permisos.Documentacion.DOCUMENTACION_ECF_VER, categoria: "Documentación", columna: COLUMNA_OTROS, label: "Ver Documentación ECF" },

  // Serie Fiscal
  { nombre: Permisos.SerieFiscal.LISTAR, categoria: "Serie Fiscal", columna: COLUMNA_LISTAR },
  { nombre: Permisos.SerieFiscal.EDITAR, categoria: "Serie Fiscal", columna: COLUMNA_EDITAR },
  { nombre: Permisos.SerieFiscal.CREAR, categoria: "Serie Fiscal", columna: COLUMNA_CREAR },

  // Item
  { nombre: Permisos.Items.LISTAR, categoria: "Item", columna: COLUMNA_LISTAR },
  { nombre: Permisos.Items.EDITAR, categoria: "Item", columna: COLUMNA_EDITAR },
  { nombre: Permisos.Items.CREAR, categoria: "Item", columna: COLUMNA_CREAR },
  { nombre: Permisos.Items.EXPORTAR, categoria: "Item", columna: COLUMNA_OTROS, label: "Exportar" },

  // Compañía Padre
  { nombre: Permisos.ReportesCompaniasVinculadas.LISTAR_TRANSACCIONES, categoria: "Compañía Padre", columna: COLUMNA_OTROS, label: "Listar Transacciones" },
  { nombre: Permisos.Compania.BLOQUEAR, categoria: "Compañía Padre", columna: COLUMNA_OTROS, label: "Bloquear Compañías" },
  { nombre: Permisos.Compania.LISTAR_HIJAS, categoria: "Compañía Padre", columna: COLUMNA_OTROS, label: "Listar Compañías" },
  { nombre: Permisos.ReportesCompaniasVinculadas.LISTAR_TERMINALES, categoria: "Compañía Padre", columna: COLUMNA_OTROS, label: "Listar Terminales" },
  { nombre: Permisos.ReportesCompaniasVinculadas.LISTAR_COMERCIOS, categoria: "Compañía Padre", columna: COLUMNA_OTROS, label: "Listar Comercios" },
  { nombre: Permisos.Compania.CREAR_VINCULADA, categoria: "Compañía Padre", columna: COLUMNA_OTROS, label: "Solicitud de Creación" },
  { nombre: Permisos.Compania.EDITAR_VINCULADA, categoria: "Compañía Padre", columna: COLUMNA_OTROS, label: "Editar Compañías" },
  { nombre: Permisos.Compania.INGRESAR_VINCULADA, categoria: "Compañía Padre", columna: COLUMNA_OTROS, label: "Ingresar a Compañías" },

  // Categoria
  { nombre: Permisos.Categoria.LISTAR, categoria: "Categoria", columna: COLUMNA_LISTAR },
  { nombre: Permisos.Categoria.EDITAR, categoria: "Categoria", columna: COLUMNA_EDITAR },
  { nombre: Permisos.Categoria.CREAR, categoria: "Categoria", columna: COLUMNA_CREAR },
  { nombre: Permisos.Categoria.EXPORTAR, categoria: "Categoria", columna: COLUMNA_OTROS, label: "Exportar" },

  // Vendedor
  { nombre: Permisos.Vendedor.LISTAR, categoria: "Vendedor", columna: COLUMNA_LISTAR },
  { nombre: Permisos.Vendedor.EDITAR, categoria: "Vendedor", columna: COLUMNA_EDITAR },
  { nombre: Permisos.Vendedor.CREAR, categoria: "Vendedor", columna: COLUMNA_CREAR },
  { nombre: Permisos.Vendedor.EXPORTAR, categoria: "Vendedor", columna: COLUMNA_OTROS, label: "Exportar" },

  // Terminal POS
  { nombre: Permisos.TerminalPOS.LISTAR, categoria: "Terminal POS", columna: COLUMNA_LISTAR },
  { nombre: Permisos.TerminalPOS.EDITAR, categoria: "Terminal POS", columna: COLUMNA_EDITAR },
  { nombre: Permisos.TerminalPOS.CREAR, categoria: "Terminal POS", columna: COLUMNA_CREAR },

  // Forma de Pago
  { nombre: Permisos.MetodoPago.LISTAR, categoria: "Forma de Pago", columna: COLUMNA_LISTAR },
  { nombre: Permisos.MetodoPago.EDITAR, categoria: "Forma de Pago", columna: COLUMNA_EDITAR },
  { nombre: Permisos.MetodoPago.CREAR, categoria: "Forma de Pago", columna: COLUMNA_CREAR },
  { nombre: Permisos.MetodoPago.EXPORTAR, categoria: "Forma de Pago", columna: COLUMNA_OTROS, label: "Exportar" },

  // Solicitudes
  { nombre: Permisos.SolicitudTenant.EDITAR, categoria: "Solicitudes", columna: COLUMNA_EDITAR },

  // Solicitudes / Documentos
  { nombre: Permisos.SolicitudTenant.DOCUMENTOS_LISTAR, categoria: "Solicitudes / Documentos", columna: COLUMNA_LISTAR },
  { nombre: Permisos.SolicitudTenant.DOCUMENTOS_CREAR, categoria: "Solicitudes / Documentos", columna: COLUMNA_CREAR },
  { nombre: Permisos.SolicitudTenant.DOCUMENTOS_DESCARGAR, categoria: "Solicitudes / Documentos", columna: COLUMNA_OTROS, label: "Descargar" },
  { nombre: Permisos.SolicitudTenant.DOCUMENTOS_ELIMINAR, categoria: "Solicitudes / Documentos", columna: COLUMNA_CANCELAR },

  // Terceros
  { nombre: Permisos.Terceros.LISTAR, categoria: "Terceros", columna: COLUMNA_LISTAR },
  { nombre: Permisos.Terceros.EDITAR, categoria: "Terceros", columna: COLUMNA_EDITAR },
  { nombre: Permisos.Terceros.CREAR, categoria: "Terceros", columna: COLUMNA_CREAR },
  { nombre: Permisos.Terceros.EXPORTAR, categoria: "Terceros", columna: COLUMNA_OTROS, label: "Exportar" },

  // Carga Masiva
  { nombre: Permisos.CargaMasiva.CARGAR, categoria: "Carga Masiva", columna: COLUMNA_CREAR },

  // Condición de Pago
  { nombre: Permisos.CondicionPago.LISTAR, categoria: "Condición de Pago", columna: COLUMNA_LISTAR },
  { nombre: Permisos.CondicionPago.CREAR, categoria: "Condición de Pago", columna: COLUMNA_CREAR },
  { nombre: Permisos.CondicionPago.EDITAR, categoria: "Condición de Pago", columna: COLUMNA_EDITAR },

  // Auditoría
  { nombre: Permisos.LogAuditoria.LISTAR, categoria: "Auditoría", columna: COLUMNA_LISTAR },

  // Reporte 606
  { nombre: Permisos.Reporte606.IMPRIMIR, categoria: "Reporte 606", columna: COLUMNA_IMPRIMIR, label: "Imprimir" },

  // Reporte 607
  { nombre: Permisos.Reporte607.IMPRIMIR, categoria: "Reporte 607", columna: COLUMNA_IMPRIMIR, label: "Imprimir" },

  // Transacciones Recurrentes
  { nombre: Permisos.TransaccionesRecurrentes.Listar, categoria: "Transacciones Recurrentes", columna: COLUMNA_LISTAR },
  { nombre: Permisos.TransaccionesRecurrentes.Crear, categoria: "Transacciones Recurrentes", columna: COLUMNA_CREAR },
  { nombre: Permisos.TransaccionesRecurrentes.Editar, categoria: "Transacciones Recurrentes", columna: COLUMNA_EDITAR },
  { nombre: Permisos.TransaccionesRecurrentes.Cancelar, categoria: "Transacciones Recurrentes", columna: COLUMNA_CANCELAR },
];
